export default __webpack_public_path__ + "static/media/Firebase.281a7808.svg";